import { BaseButton,  Button, ContextualMenuItemType, DefaultButton, Dialog, DialogFooter, DialogType, Icon,  IContextualMenuItem, IContextualMenuProps,  Label,  PrimaryButton } from 'office-ui-fabric-react';
import React, { Fragment,  useContext,  useState } from 'react';
import { WsSalesSolutionAction, WsSalesSolutionItem } from '../../../core';
import { findActionById, findItemById, WsSalesSolutionActionFind, WsSalesSolutionItemFind } from '../../../core/sales-actions';
import { itemFindIsAction, itemIsAction } from '../../../helpers/item-helpers';
import { WsPanelContext } from "../SalesContainerWithPanel";




const getDependencyText = (items: WsSalesSolutionItem[], itemId: string | undefined, placeholderText: string, selectAction: boolean) => {

  if (itemId) {

    let itemFind: WsSalesSolutionItemFind | WsSalesSolutionActionFind | undefined = undefined;

    if (selectAction) {
      itemFind = findActionById(items, undefined, itemId, '', { filterSelected: false, includeChildActions: true });
    } else {
      itemFind = findItemById(items, itemId, '', {});
    }

    if (itemFind) {

      if (itemFindIsAction(itemFind)) {
        // action
        return itemFind.path.slice(1).replace(/\//g, ' / ');

      } else if (itemFind.item) {
        // capability
        return `${itemFind.path}/${itemFind.item.name}`.slice(1).replace(/\//g, ' / ');

      } else {
        return '';
      }

    } else {
      return '';
    }

  } else {
    return placeholderText;
  }
};




const getMenuItems = (items: WsSalesSolutionItem[] | WsSalesSolutionAction[] | undefined, selectAction: boolean, setSelectedItem: React.Dispatch<React.SetStateAction<WsSalesSolutionItem | WsSalesSolutionAction | undefined>>) => {
  const menuItems: IContextualMenuItem[] = [];

  if (items && Array.isArray(items) && items.length > 0) {

    items.forEach((item: WsSalesSolutionItem | WsSalesSolutionAction) => {

      const menuItem: IContextualMenuItem = {
        key: `item-${item.id}`,
        text: item.name,
        subMenuProps: {
          items: []
        }
      };



      // actions

      if (selectAction) {

        const actionMenuItems = getMenuItems(item.actions, selectAction, setSelectedItem);

        if (actionMenuItems.length > 0) {

          menuItem.subMenuProps?.items?.push({
            key: `item-${item.id}-header-actions`,
            text: 'Actions',
            itemType: ContextualMenuItemType.Header
          });

          menuItem.subMenuProps?.items?.push(...actionMenuItems);
        }
      }



      // items

      if (itemIsAction(item)) {
      } else {

        const itemMenuItems = getMenuItems(item.items, selectAction, setSelectedItem);

        if (itemMenuItems.length > 0) {

          menuItem.subMenuProps?.items?.push({
            key: `item-${item.id}-header-capabilities`,
            text: 'Capabilities',
            itemType: ContextualMenuItemType.Header
          });

          menuItem.subMenuProps?.items?.push(...itemMenuItems);
        }
      }



      // click

      menuItem.onClick = (event?: React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement> | undefined) => {

        if (selectAction) {
          // select action
          if (itemIsAction(item)) {
            setSelectedItem(item);
          } else {
            setSelectedItem(undefined);
          }
  
        } else {
          // select item
          if (itemIsAction(item)) {
            setSelectedItem(undefined);
          } else {
            setSelectedItem(item);
          }
        }
      };



      // empty

      if (menuItem.subMenuProps && menuItem.subMenuProps.items && Array.isArray(menuItem.subMenuProps.items) && menuItem.subMenuProps.items.length > 0) {
        menuItem.split = true;
      } else {
        menuItem.subMenuProps = undefined;
      }



      // item

      menuItems.push(menuItem);
    });
  }

  return menuItems;
};





type WsSelectItemDialogProps = {
  title: string;
  label?: string;
  items: WsSalesSolutionItem[];
  selectAction: boolean;
  close: () => void;
  continue: (selectedItem: WsSalesSolutionItem | WsSalesSolutionAction | undefined) => void;
};

const WsSelectItemDialog = (props: WsSelectItemDialogProps) => {

  // const solutionContext = useContext(WsSalesSolutionContext);

  const [ selectedItem, setSelectedItem ] = useState<WsSalesSolutionItem | WsSalesSolutionAction | undefined>(undefined);



  const menuProps: IContextualMenuProps = React.useMemo(() => ({
    shouldFocusOnMount: true,
    subMenuHoverDelay: 250,
    items: getMenuItems(props.items, props.selectAction, setSelectedItem),
  }), [ props.items ]);



  const onDismiss = (event?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    props.close();
  };

  const onClickCancel = async (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.close();
  };

  const onClickContinue = async (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.continue(selectedItem);
  };



  return (
    <Dialog
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{
        type: DialogType.normal,
        title: props.title
      }}
      modalProps={{
        className: 'ws-select-item-dialog ws-dialog-select',
        isBlocking: false,
        styles: {
          // main: { width: 500 }
        }
      }}
    >
      <Fragment>
        <div className="ws-select-item-form">
          <div className="columns">
            <div className="column">
              {
                props.label
                &&
                <>
                  <Label>{props.label}</Label>
                </>
              }
              <DefaultButton
                text={getDependencyText(props.items, selectedItem ? selectedItem.id : undefined, props.selectAction ? 'Select Action' : 'Select Capability', props.selectAction)}
                menuProps={menuProps}
              />
              <br />
            </div>
          </div>
        </div>
      </Fragment>
      <DialogFooter>
        <>
          <DefaultButton onClick={onClickCancel}   text="Cancel" />
          <PrimaryButton onClick={onClickContinue} text="OK" style={{ marginLeft: '4px' }} disabled={ !selectedItem } />
        </>
      </DialogFooter>
    </Dialog>
  );
};




type WsSalesActionDependenciesProps = {
  title: string;
  mode: string;
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  action: WsSalesSolutionAction;
};

const WsSalesActionDependencies = ({ mode, items, setItems, action }: WsSalesActionDependenciesProps) => {

  const panelContext = useContext(WsPanelContext);

  const list: string[] | undefined = action.dependencyIds;

  const [ dialogVisible, setDialogVisible ] = useState<boolean>(false);

  return (
    <div className="ws-sales-solution-admin-metrics-list" style={{ marginTop: '5px' }}>
      {/* <h6 className="title is-6" style={{ marginBottom: '0px' }}>{title}</h6> */}



      {/* list */}

      {
        list && Array.isArray(list) && list.length > 0
        ?
        list.map((listItem, index: number) => {

          const key = `ws-sales-solution-metric-${index}-${listItem}`;

          return (
            <div key={key} data-key={key} className="ws-class ws-sales-solution-admin-metrics-item">
              {
                mode === 'edit'

                ?

                // edit

                <>
                  <div className="ws-sales-solution-admin-metrics-item-field" style={{ fontSize: '13px', fontWeight: 400, flexGrow: 1, paddingTop: '4px' }}>{getDependencyText(items, listItem, '', true)}</div>

                  {/* delete */}

                  <div className="ws-sales-solution-admin-metrics-item-field" style={{ width: '20px' }}>
                    <Icon className="ws-sales-solution-metric-delete" iconName={'Delete'} style={{ fontSize: '17px' }} onClick={
                      () => {
                        const nextItems = [ ...items ];

                        action.dependencyIds = action.dependencyIds.filter((did) => did !== listItem);

                        setItems(nextItems);
                      }
                    } />
                  </div>
                </>

                :

                // show

                <>
                  <div style={{ fontSize: '13px' }}>
                    <a onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                      e.preventDefault();

                      const actionFind = findActionById(items, undefined, listItem, '', { filterSelected: false, includeChildActions: true });

                      if (actionFind) {
                        panelContext.setShowAction(actionFind.action);
                      }
                    }}>
                      {getDependencyText(items, listItem, '', true)}
                    </a>
                  </div>
                </>
              }
            </div>
          );
        })
        :
        <>
          None
        </>
      }



      {/* add button */}

      {
        mode === 'edit'
        &&
        <>
          <div className="ws-sales-solution-metric-add" style={{ marginTop: '5px' }}
            onClick={() => {
              setDialogVisible(true);
            }}
          >
            <Icon iconName={'CircleAdditionSolid'} style={{ fontSize: '17px', verticalAlign: 'middle', marginTop: '-2px' }}/> Add Dependency Action
          </div>

          {
            dialogVisible
            &&
            <WsSelectItemDialog
              title="Add Dependency Action"
              items={items}
              selectAction={true}
              close={() => {
                setDialogVisible(false);
              }}
              continue={(selectedItem: WsSalesSolutionItem | WsSalesSolutionAction | undefined) => {

                if (selectedItem) {

                  const findItem = action.dependencyIds.find((did) => did === selectedItem.id);

                  if (findItem) {
                    // item already added

                  } else {

                    // add item
                    const nextItems = [ ...items ];
                    action.dependencyIds.push(selectedItem.id);
                    setItems(nextItems);
                  }
                }

                setDialogVisible(false);
              }}
            />
          }
        </>
      }
    </div>
  );
}




type WsSalesCapabilityLinksProps = {
  title: string;
  mode: string;
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  capability: WsSalesSolutionItem;
};

const WsSalesCapabilityLinks = ({ mode, items, setItems, capability }: WsSalesCapabilityLinksProps) => {

  const panelContext = useContext(WsPanelContext);

  const list: string[] | undefined = capability.linkIds;

  const [ dialogVisible, setDialogVisible ] = useState<boolean>(false);

  return (
    <div className="ws-sales-solution-admin-metrics-list" style={{ marginTop: '5px' }}>
      {/* <h6 className="title is-6" style={{ marginBottom: '0px' }}>{title}</h6> */}



      {/* list */}

      {
        list && Array.isArray(list) && list.length > 0
        ?
        list.map((listItem, index: number) => {

          const key = `ws-sales-solution-metric-${index}-${listItem}`;

          return (
            <div key={key} data-key={key} className="ws-class ws-sales-solution-admin-metrics-item">
              {
                mode === 'edit'

                ?

                // edit

                <>
                  <div className="ws-sales-solution-admin-metrics-item-field" style={{ fontSize: '13px', fontWeight: 400, flexGrow: 1, paddingTop: 5 }}>{getDependencyText(items, listItem, '', false)}</div>

                  {/* delete */}

                  <div className="ws-sales-solution-admin-metrics-item-field" style={{ width: '20px' }}>
                    <Icon className="ws-sales-solution-metric-delete" iconName={'Delete'} style={{ fontSize: '17px' }} onClick={
                      () => {
                        const nextItems = [ ...items ];

                        capability.linkIds = capability.linkIds.filter((did) => did !== listItem);

                        setItems(nextItems);
                      }
                    } />
                  </div>
                </>

                :

                // show

                <>
                  <div style={{ fontSize: '13px' }}>
                    <a onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                      e.preventDefault();

                      const itemFind = findItemById(items, listItem, '', {});

                      if (itemFind) {
                        panelContext.setShowAction(itemFind.item);
                      }
                    }}>
                      {getDependencyText(items, listItem, '', false)}
                    </a>
                  </div>
                </>
              }
            </div>
          );
        })
        :
        <>
          None
        </>
      }



      {/* add button */}

      {
        mode === 'edit'
        &&
        <>
          <div className="ws-sales-solution-metric-add" style={{ marginTop: '5px' }}
            onClick={() => {
              setDialogVisible(true);
            }}
          >
            <Icon iconName={'CircleAdditionSolid'} style={{ fontSize: '17px', verticalAlign: 'middle', marginTop: '-2px' }}/> Add Linked Capability
          </div>

          {
            dialogVisible
            &&
            <WsSelectItemDialog
              title="Add Linked Capability"
              items={items}
              selectAction={false}
              close={() => {
                setDialogVisible(false);
              }}
              continue={(selectedItem: WsSalesSolutionItem | WsSalesSolutionAction | undefined) => {

                if (selectedItem) {

                  const findItem = capability.linkIds.find((did) => did === selectedItem.id);

                  if (findItem) {
                    // item already added

                  } else {

                    // add item
                    const nextItems = [ ...items ];
                    capability.linkIds.push(selectedItem.id);
                    setItems(nextItems);
                  }
                }

                setDialogVisible(false);
              }}
            />
          }
        </>
      }
    </div>
  );
}



export {
  WsSelectItemDialog,
  WsSalesActionDependencies,
  WsSalesCapabilityLinks
};
